import { render, staticRenderFns } from "./setnickname.vue?vue&type=template&id=bab67fa0&scoped=true&"
import script from "./setnickname.vue?vue&type=script&lang=js&"
export * from "./setnickname.vue?vue&type=script&lang=js&"
import style0 from "./setnickname.vue?vue&type=style&index=0&id=bab67fa0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab67fa0",
  null
  
)

export default component.exports